import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ImgAurobilcarsDarkTransparent } from "../assets/images";
import Navbar from "../components/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import TopBar from "../components/TopBar";
import { getNavToggle, removeNavToggle, setNavToggle } from "../utils/navbar.utils";

const Layout = () => {
  const topBarRef = useRef(null);
  const [topbarheight, setTopbarHeight] = useState(0);

  useEffect(() => {
    if (topBarRef.current) {
      const height = topBarRef.current.clientHeight;
      setTopbarHeight(height);
    }
  }, []);

  const activeCollapse = getNavToggle();

  const [collapse, setCollapse] = useState(activeCollapse);

  const collapseToggle = () => {
    setCollapse((prev) => {
      if (prev) {
        removeNavToggle();
      } else {
        setNavToggle();
      }

      return !prev;
    });
  };

  const navbarHoverMouseEnterHandler = () => {
    setCollapse(false);
  };

  const navbarHoverMouseLeaveHandler = () => {
    if (activeCollapse) {
      setCollapse(true);
    }
  };

  return (
    <LayoutContainer className="d-flex position-relative">
      <SidebarContainer
        onMouseEnter={navbarHoverMouseEnterHandler}
        onMouseLeave={navbarHoverMouseLeaveHandler}
        className={`vh-100 position-fixed d-flex flex-column ${collapse ? "sidebar-close" : ""}`}
      >
        <LogoContainer className="d-flex align-items-center px-3 py-1">
          <Logo
            className="flex-shrink-0"
            style={{ backgroundImage: `url(${ImgAurobilcarsDarkTransparent})` }}
          />
          {!collapse && <h5 className="flex-grow-1 ms-2 mb-0">Aurobil Cars</h5>}
        </LogoContainer>
        <ScrollBar className="overflow-y-auto flex-grow-1 p-3">
          <Navbar collapse={collapse} collapseToggle={collapseToggle} />
        </ScrollBar>
      </SidebarContainer>

      <SidebarContainerBg
        className={`${collapse ? "sidebar-bg-close" : "sidebar-bg-open"}`}
        onClick={collapseToggle}
      />

      <Main className={`${collapse ? "main-collapse" : ""}`}>
        <TopBarContainer ref={topBarRef} className="container-fluid">
          <div className="row">
            <div className="col">
              <TopBar collapse={collapse} collapseToggle={collapseToggle} />
            </div>
          </div>
        </TopBarContainer>

        <ContentWrapper $topbarheight={topbarheight} className="container-fluid">
          <div className="row">
            <div className="col">
              <Outlet />
            </div>
          </div>
        </ContentWrapper>
      </Main>
    </LayoutContainer>
  );
};

export default Layout;

const ScrollBar = styled.nav`
  &::-webkit-scrollbar {
    width: 5px;
  }

  &:hover::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--main-color);
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--main-hover-color);
  }
`;

const LogoContainer = styled.div`
  border-bottom: 1px solid #a3aed159;
  color: var(--main-color);

  &:hover {
    color: var(--main-hover-color);
  }
`;

const Logo = styled.div`
  height: 3rem;
  width: 3rem;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
`;

const LayoutContainer = styled.div`
  .sidebar-close {
    opacity: 0;
    width: 0;
    position: absolute !important;
    left: -5rem;
  }

  .sidebar-bg-close {
    display: none;
  }

  .main-collapse {
    margin-left: 0;
  }

  @media (min-width: 992px) {
    .sidebar-close {
      opacity: 1;
      width: 5rem;
      position: fixed !important;
      left: 0;
    }

    .main-collapse {
      margin-left: 5rem;
    }

    .sidebar-bg-open {
      display: none;
    }
  }
`;

const SidebarContainer = styled.div`
  background-color: var(--main-dark-bg);
  width: 16rem;
  z-index: 6;
`;

const SidebarContainerBg = styled.div`
  background-color: var(--main-overlay-bg);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
`;

const Main = styled.div`
  width: 100%;
  @media (min-width: 992px) {
    margin-left: 16rem;
  }
`;

const ContentWrapper = styled.div`
  background-color: var(--main-white-bg);
  min-height: calc(100vh - ${({ $topbarheight }) => $topbarheight}px);
`;

const TopBarContainer = styled.div`
  background-color: #fff;
`;
